/**
 * Comment API endpoints
 */
import { Comment, CommentCreateData, CommentUpdateData } from '@/types/comments';
import axiosClient from './axiosClient';

export const commentAPI = {
  /**
   * Get comments for a specific task
   */
  getComments: async (taskId: string, params?: {
    skip?: number;
    limit?: number;
  }): Promise<Comment[]> => {
    const response = await axiosClient.get<Comment[]>('/comments', {
      params: {
        task_id: taskId,
        ...params
      }
    });
    return response.data;
  },

  /**
   * Get a specific comment by ID
   */
  getComment: async (commentId: string): Promise<Comment> => {
    const response = await axiosClient.get<Comment>(`/comments/${commentId}`);
    return response.data;
  },

  /**
   * Create a new comment
   */
  createComment: async (data: CommentCreateData): Promise<Comment> => {
    const response = await axiosClient.post<Comment>('/comments', data);
    return response.data;
  },

  /**
   * Update a comment
   */
  updateComment: async (commentId: string, data: CommentUpdateData): Promise<Comment> => {
    const response = await axiosClient.put<Comment>(`/comments/${commentId}`, data);
    return response.data;
  },

  /**
   * Delete a comment
   */
  deleteComment: async (commentId: string): Promise<void> => {
    await axiosClient.delete(`/comments/${commentId}`);
  },

  /**
   * Get comments count for a task
   */
  getCommentsCount: async (taskId: string): Promise<{ task_id: string; comments_count: number }> => {
    const response = await axiosClient.get<{ task_id: string; comments_count: number }>(
      `/comments/task/${taskId}/count`
    );
    return response.data;
  },
};